import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import VerifiedIcon from '@mui/icons-material/Verified';

import { DoubleArrow } from '@mui/icons-material';
import {
    Autocomplete,
    Button,
    Container,
    Grid,
    LinearProgress,
    Link,
    Paper,
    TextField,
    ToggleButton,
    Tooltip,
    Typography
} from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes, ToastContext } from '../../contexts';
import { ContattiWizardContext, ContattiWizardProvider } from './ContattiWizardContext';
import { isEmail } from '../../../helpers';




const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage,
        showLoadingMessage,
        closeLoadingMessage,
    } = useContext(ToastContext);

    const {
        addBreadcrumbToken,
        replaceBreadcrumbToken,
        getRouteTo,
        navigateTo,
    } = useContext(NavContext);

    const {

        isLoadingContatti,
        getContattiAsync,

        isLoadingTipiContatti,
        getTipiContattiAsync,

        isUpdatingContatti,
        updateContattiAsync,

        isLoadingUfficio,
        getUfficioAsync,

        isUpdatingUfficio,
        updateUfficioAsync,

        isLoadingUffici,
        getUfficiAsync,

        state,
        setState,

    } = useContext(ContattiWizardContext);

    const {
        ufficioId,
    } = useParams();

    const {
        ufficio,
        uffici,
        contatti,
        tipiContatti,
        tipiContattiOptions,
    } = state;

    const [isLoading, setIsLoading] = useState(isLoadingContatti);
    useEffect(() => {
        setIsLoading(isLoadingContatti || isLoadingTipiContatti || isUpdatingContatti || isLoadingUffici || isLoadingUfficio || isUpdatingUfficio)
    }, [isLoadingContatti, isLoadingTipiContatti, isUpdatingContatti, isLoadingUffici, isLoadingUfficio, isUpdatingUfficio]);

    const addClickHandler = () => {
        var newContatto = {
            id: `id${Date.now()}`,
            ufficioId: ufficioId,
            tipoContattoId: "",
            padreId: null,
            descrizione: "",
            valore: "",
            testoGrassetto: false,
            testoCorsivo: false,
            testoCollegamento: false,
            linkCollegamento: null,
        }
        setState({ contatti: { result: [newContatto, ...contatti.result] } });
    }


    const saveClickHandler = () => {
        var data = JSON.parse(JSON.stringify(contatti.result));
        data.forEach(x => {
            if (typeof x.id === "string") {
                x.tempId = x.id;
                x.id = 0;
            }

            if (typeof x.padreId === "string") {
                x.tempPadreId = x.padreId;
                x.padreId = 0;
            }
        });

        updateContattiAsync(ufficioId, data);
    }

    const nextUfficioHandler = async () => {
        var data = JSON.parse(JSON.stringify(contatti.result));
        data.forEach(x => {
            if (typeof x.id === "string") {
                x.tempId = x.id;
                x.id = 0;
            }

            if (typeof x.padreId === "string") {
                x.tempPadreId = x.padreId;
                x.padreId = 0;
            }
        });

        await updateContattiAsync(ufficioId, data);
        if (ufficio && !ufficio.convalidato) {
            await updateUfficioAsync(ufficio.id, { ...ufficio, convalidato: true });
        }
        getUfficiAsync();
    }

    const getContattiIds = (contattoId) => {
        var tempContattiIds = [];
        var tempContatti = contatti.result.filter(x => x.padreId == contattoId);
        tempContattiIds = [...tempContatti?.map(x => x.id)];
        tempContatti?.forEach(x => {
            tempContattiIds = [...tempContattiIds, ...getContattiIds(x.id)];
        });
        return tempContattiIds
    }

    const renderUfficioItem = (ufficio) => {
        return <>
            {
                ufficio.id != 0 && ufficio.sottotitolo?.length > 0 &&
                <Grid item xs={12}>
                    <Typography fontSize={12} fontWeight={700}>
                        {ufficio.sottotitolo}
                    </Typography>
                </Grid>
            }
            {
                ufficio.id != 0 && ufficio.msg?.length > 0 &&
                <Grid item xs={2}>
                    <Typography fontSize={12} fontWeight={700}>
                        comunicazioni di servizio
                    </Typography>
                </Grid>
            }
            {
                ufficio.id != 0 && ufficio.msg?.length > 0 &&
                <Grid item xs={10}>
                    <Typography fontSize={12} color={"red"}>
                        {ufficio.msg}
                    </Typography>
                </Grid>
            }
            {
                ufficio.id != 0 &&
                <Grid container>
                    <Grid item xs={2}>
                        <Typography fontSize={12}>
                            comune
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography fontSize={12}>
                            {ufficio.comune?.denominazioneIt}
                        </Typography>
                    </Grid>
                    < Grid item xs={2}>
                        <Typography fontSize={12}>
                            indirizzo
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        <Typography fontSize={12}>
                            {ufficio.indirizzo}
                        </Typography>
                    </Grid>
                    {
                        ufficio.cap && ufficio.cap.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                cap
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.cap && ufficio.cap.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.cap}
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.patrono && ufficio.patrono.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                festività locale
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.patrono && ufficio.patrono.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.patrono}
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.lingueParlate && ufficio.lingueParlate.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                lingue parlate
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.lingueParlate && ufficio.lingueParlate.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.lingueParlate}
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.videoConferenza && ufficio.videoConferenza.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                video conferenza
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.videoConferenza && ufficio.videoConferenza.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.videoConferenza}
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.altreSedi && ufficio.altreSedi.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                altre sedi
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.altreSedi && ufficio.altreSedi.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.altreSedi}
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.infoAggiuntive && ufficio.infoAggiuntive.length > 0 &&
                        <Grid item xs={2}>
                            <Typography fontSize={12}>
                                informazioni
                            </Typography>
                        </Grid>
                    }
                    {
                        ufficio.infoAggiuntive && ufficio.infoAggiuntive.length > 0 &&
                        <Grid item xs={10}>
                            <Typography fontSize={12}>
                                {ufficio.infoAggiuntive}
                            </Typography>
                        </Grid>
                    }
                </Grid>
            }
        </>
    }

    const renderContattiList = (lista = [], even = true, padreId = null) => {
        var contattiValid = lista?.filter(x => x.padreId == padreId);
        // contattiValid.sort((a, b) => a.ordine - b.ordine);
        return contattiValid.map(contatto => {
            if (contatti.result.find(x => x.padreId == contatto.id)) {
                return <Grid item container xs={12} key={contatto.id}>
                    <Grid item xs={12}>
                        <Typography fontSize={12} fontWeight="bold" marginTop={1}>
                            {contatto.descrizione?.toLowerCase()}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} marginLeft={3} sx={{
                        width: "100%", marginY: 0.5, padding: 0.5, backgroundColor: even ? 'white' : '#0059b314'
                    }}>
                        {
                            renderContattiList(contatti.result, !even, contatto.id)
                        }
                    </Grid>
                </Grid>
            } else {
                return <Grid item container xs={12} key={contatto.id}>
                    <Grid item xs={2}>
                        <Typography fontSize={12}>
                            {contatto.descrizione?.toLowerCase()}
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        {
                            contatto.testoCollegamento ?
                                <Typography fontSize={12} fontStyle={contatto.testoCorsivo ? "italic" : null}
                                    fontWeight={contatto.testoGrassetto ? "bold" : null}
                                    sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                    <Link href={isEmail(contatto.linkCollegamento) ? `mailto:${contatto.linkCollegamento}` : `//${contatto.linkCollegamento}`} target="_blank">
                                        {contatto.valore}
                                    </Link>
                                </Typography>
                                :
                                <Typography fontSize={12} fontStyle={contatto.testoCorsivo ? "italic" : null}
                                    fontWeight={contatto.testoGrassetto ? "bold" : null}
                                    sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                    {contatto.valore}
                                </Typography>
                        }
                    </Grid>
                </Grid>
            }
        })
    }

    const renderContattiWizard = (lista = [], padreId = null) => {
        if (lista && lista.length > 0) {
            var contattiValid = lista.filter(x => x.padreId == padreId);
            contattiValid.sort((a, b) => a.ordine - b.ordine);
            return contattiValid?.map(contatto =>
                <Grid container key={contatto.id}>
                    <Grid item xs={12} paddingTop={1}>
                        <Paper variant="outlined">
                            <Grid container padding={1} alignItems="center">
                                <Grid item xs={12} container alignItems="center" justifyContent="space-between">
                                    <Grid item xs="auto" container alignItems="center" spacing={2}>
                                        {/* <Grid item xs="auto">
                                            <Button disabled={contattiValid[0] === contatto} variant="contained" disableElevation color="success"
                                                sx={{ minWidth: 40, width: 40, }}
                                                onClick={() => {
                                                    contatto.ordine = contattiValid[contattiValid.indexOf(contatto) - 1].ordine - 1;
                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                                }}>
                                                <NorthIcon />
                                            </Button>
                                        </Grid>
                                        <Grid item xs="auto">
                                            <Button disabled={contattiValid[contattiValid.length - 1] === contatto} variant="contained" disableElevation color="success" sx={{ minWidth: 40, width: 40, }}
                                                onClick={() => {
                                                    contatto.ordine = contattiValid[contattiValid.indexOf(contatto) + 1].ordine + 1;
                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                                }}>
                                                <SouthIcon />
                                            </Button>
                                        </Grid>
                                        <Grid item xs="auto" pr={8}>
                                            <TextField
                                                sx={{ minWidth: 70, width: 70, my: 1 }}
                                                variant='outlined'
                                                size='small'
                                                onChange={e => {
                                                    contatto.ordine = e.target.value;
                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } });
                                                }}
                                                inputProps={{ style: { textAlign: 'center' } }}
                                                value={contatto.ordine ?? 0}
                                                type="number">
                                            </TextField>
                                        </Grid> */}
                                        <Grid item xs="auto" container alignItems="center" spacing={4} >
                                            {
                                                lista.filter(x => x.padreId == contatto.id).length == 0 &&
                                                <Grid item xs="auto" container alignItems="center" spacing={2}>
                                                    <Grid item xs="auto">
                                                        <Tooltip title="Testo grassetto">
                                                            <ToggleButton
                                                                color='primary'
                                                                selected={contatto.testoGrassetto}
                                                                onChange={() => {
                                                                    contatto.testoGrassetto = !contatto.testoGrassetto;
                                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } });
                                                                }}
                                                                aria-label="bold">
                                                                <FormatBoldIcon />
                                                            </ToggleButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item xs="auto">
                                                        <Tooltip title="Testo corsivo">
                                                            <ToggleButton
                                                                color='primary'
                                                                selected={contatto.testoCorsivo}
                                                                onChange={() => {
                                                                    contatto.testoCorsivo = !contatto.testoCorsivo;
                                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } });
                                                                }}
                                                                value="italic"
                                                                aria-label="italic">
                                                                <FormatItalicIcon />
                                                            </ToggleButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item xs="auto" mr={2}>
                                                        <Tooltip title="Testo collegamento">
                                                            <ToggleButton
                                                                color='primary'
                                                                selected={contatto.testoCollegamento}
                                                                onChange={() => {
                                                                    contatto.testoCollegamento = !contatto.testoCollegamento;
                                                                    setState({ contatti: { ...contatti, result: [...contatti.result] } });
                                                                }}
                                                                value="underlined"
                                                                aria-label="underlined">
                                                                <FormatUnderlinedIcon />
                                                            </ToggleButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            }
                                            <Grid item xs="auto" >
                                                <Button variant="contained" disableElevation color="error"
                                                    onClick={() => {
                                                        contatti.result.forEach(x => {
                                                            if (x.padreId == contatto.id || contatto.tempId == x.padreId)
                                                                x.padreId = null;
                                                        });
                                                        setState({
                                                            contatti: {
                                                                ...contatti,
                                                                result: [...contatti.result.filter(x => x.id != contatto.id || x.tempId != contatto.tempId)]
                                                            }
                                                        });
                                                    }}>
                                                    <DeleteIcon />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <Button variant="contained" disableElevation color="primary"
                                            onClick={() => {
                                                var newContatto = {
                                                    id: `id${Date.now()}`,
                                                    ufficioId: contatto.ufficioId,
                                                    tipoContattoId: "",
                                                    padreId: contatto.id,
                                                    descrizione: "",
                                                    valore: "",
                                                    testoGrassetto: false,
                                                    testoCorsivo: false,
                                                    testoCollegamento: false,
                                                    ordine: 0,
                                                    linkCollegamento: "",
                                                }
                                                setState({
                                                    contatti: {
                                                        ...contatti,
                                                        result: [...contatti.result, newContatto]
                                                    }
                                                })
                                            }}>
                                            <AddIcon />
                                        </Button>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={3} pl={8} pr={1} pt={2}>
                                    <Grid item xs={12}>
                                        <Autocomplete
                                            options={tipiContattiOptions}
                                            size="small"
                                            renderInput={(params) => <TextField {...params} label="Tipo" />}
                                            fullWidth
                                            onChange={(e, value) => {
                                                var tempTipoContatto = tipiContatti.result.find(x => x.id == value?.tipoContattoId);
                                                contatto.tipoContattoId = value?.tipoContattoId;
                                                contatto.testoGrassetto = tempTipoContatto.testoGrassettoDefault;
                                                contatto.testoCorsivo = tempTipoContatto.testoCorsivoDefault;
                                                contatto.testoCollegamento = tempTipoContatto.testoCollegamentoDefault;
                                                contatto.descrizione = tempTipoContatto.nome;
                                                setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                            }}
                                            value={tipiContattiOptions.find(option => option.tipoContattoId == contatto.tipoContattoId) ?? ""}
                                        />
                                    </Grid>
                                    <Grid item xs={12} paddingTop={1}>
                                        <TextField
                                            variant='outlined'
                                            size='small'
                                            fullWidth
                                            onChange={e => {
                                                contatto.descrizione = e.target.value;
                                                setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                            }}
                                            value={contatto.descrizione ?? ""}
                                            label="Descrizione">
                                        </TextField>
                                    </Grid>
                                </Grid>
                                {
                                    lista.filter(x => x.padreId == contatto.id).length == 0 &&
                                    <Grid item xs pr={8} pt={2}>
                                        <TextField
                                            placeholder="Url collegamento"
                                            fullWidth
                                            size="small"
                                            onChange={e => {
                                                contatto.linkCollegamento = e.target.value;
                                                setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                            }}
                                            value={contatto.linkCollegamento ?? ""}
                                            label="Url collegamento" />
                                        <TextField
                                            multiline
                                            variant='outlined'
                                            size='small'
                                            label="Valore"
                                            onChange={e => {
                                                contatto.valore = e.target.value;
                                                setState({ contatti: { ...contatti, result: [...contatti.result] } })
                                            }}
                                            value={contatto.valore ?? ""}
                                            fullWidth
                                            sx={{ marginTop: 1 }}>
                                        </TextField>
                                    </Grid>
                                }
                            </Grid>
                        </Paper>
                        <Grid item xs={12} container paddingLeft={5}>
                            {
                                renderContattiWizard(contatti.result, contatto.id)
                            }
                        </Grid>
                    </Grid>
                </Grid>
            )
        }
        return <></>
    }

    useEffect(() => {
        if (uffici?.totalCount > 0) {
            navigateTo(NavRoutes.ContattiWizard, [uffici.result[0].id]);
            replaceBreadcrumbToken(uffici.result[0].nome, getRouteTo(NavRoutes.Ufficio, [uffici.result[0].id]), getRouteTo(NavRoutes.Ufficio, [ufficio.id]));
        }
        if (uffici?.totalCount == 0) {
            showWarningMessage("Tutti gli uffici sono stati convalidati");
        }
    }, [uffici, ufficio]);

    useEffect(() => {
        if (user && ufficioId) {
            getUfficioAsync(ufficioId);
            getContattiAsync(ufficioId);
        }
    }, [ufficioId, user]);

    useEffect(() => {
        if (user) {
            addBreadcrumbToken("Editor attributi")
            getTipiContattiAsync();
        }
    }, [user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid item xs={12}>
                    <PageHeader
                        disabled={isLoading}
                        add
                        onAddClick={addClickHandler}
                        save
                        onSaveClick={saveClickHandler}
                        title={
                            ufficio?.convalidato ?
                                <>
                                    {`${ufficio?.nome}`}
                                    <VerifiedIcon color="success" />
                                </>
                                :
                                <>
                                    {`${ufficio?.nome}`}
                                    <NewReleasesIcon color="warning" />
                                </>
                        }
                        subtitle="Gestisci gli attributi" />
                </Grid>
                <Grid item xs={12} paddingTop={5} container justifyContent="flex-end">
                    <Button variant="contained" onClick={nextUfficioHandler} disabled={isLoading} color="success">
                        {
                            ufficio?.convalidato ?
                                "Passa al prossimo ufficio"
                                :
                                "Convalida e passa al prossimo ufficio"
                        }

                        <DoubleArrow />
                    </Button>
                </Grid>
                <Grid item xs={12} paddingTop={4}>
                    <Paper sx={{
                        marginX: 2, backgroundColor: '#00d70d14'
                    }} elevation={0}>
                        <Grid container padding={2}>
                            {
                                ufficio &&
                                renderUfficioItem(ufficio)
                            }
                        </Grid>
                    </Paper>
                    <Paper sx={{
                        marginX: 2, backgroundColor: '#0059b314', marginTop: 2
                    }} elevation={0}>
                        <Grid container padding={2}>
                            {
                                contatti &&
                                renderContattiList(contatti?.result)
                            }
                        </Grid>
                    </Paper>
                    {
                        ufficio && ufficio.dataAggiornamento && ufficio.dataAggiornamento.length > 0 &&
                        <Paper sx={{
                            marginX: 2, backgroundColor: '#00d70d14', marginTop: 2
                        }} elevation={0}>
                            <Grid container padding={2}>
                                <Grid item xs={2}>
                                    <Typography fontSize={12}>
                                        data aggiornamento
                                    </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                        <Typography fontSize={12}>
                                            {(new Date(ufficio.dataAggiornamento)).getDate()}
                                            &nbsp;
                                            {(new Date(ufficio.dataAggiornamento)).toLocaleString('default', { month: 'long' })}
                                            &nbsp;
                                            {(new Date(ufficio.dataAggiornamento)).getFullYear()}
                                        </Typography>
                                    </Grid>
                            </Grid>
                        </Paper>
                    }
                </Grid>
                <Grid item xs={12} paddingTop={2}>
                    {
                        renderContattiWizard(contatti?.result)
                    }
                </Grid>
            </Container>
        </>
    );
}

export const ContattiWizardPage = () => {

    return (
        <ContattiWizardProvider>
            <PageContent />
        </ContattiWizardProvider>
    );
}